import React, { FunctionComponent, useState } from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';

import Button from '../../../UI/Button';
import Modal from '../../../UI/Modal';
import AddMoney from './Form';
import { sendEvent2 } from '../../../../utils/tracking';

const Recharge: FunctionComponent = () => {
  const [modalState, setModalState] = useState(false);

  const walletBalance = useSelector((state: any) => _get(state, 'fasTag.balance', ''));

  const toggleModal = () => {
    if (modalState) {
      sendEvent2(
        'close_btn',
        {
          event_action: 'click',
          event_category: 'we_wallet_txn_pop_up',
          screen_name: 'ft_homescreen',
          target_product: 'fastag',
          event_platform: 'web',
        },
        true,
      );
    }
    setModalState((prevState) => !prevState);
  };

  const updateAction = (modalState: boolean) => setModalState(modalState);

  return (
    <div className="z1">
      <Button
        variant="contained"
        color="#304FFE"
        clickHandler={() => {
          toggleModal();
          sendEvent2(
            'add_money_btn',
            {
              event_action: 'click',
              event_category: 'top_nav',
              screen_name: 'ft_homescreen',
              miscellaneous: JSON.stringify({
                balance: walletBalance,
              }),
              target_product: 'fastag',
              event_platform: 'web',
            },
            true,
          );
        }}
      >
        Add Money
      </Button>
      <Modal isOpen={modalState} onClose={toggleModal}>
        <AddMoney walletBalance={walletBalance} updateAction={updateAction} />
      </Modal>
    </div>
  );
};

export default Recharge;
